import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { removeSvgFocusIE } from "utils/removeSvgFocusIE";
import { handleAEMReactLink } from "utils/handleAEMReactLink";
import { clearErrors } from "../Layout/MainContent/DownloadAndDelete/actions";

class ScrollToTop extends Component {
  handleScroll = () => {
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        left: 0
      });
    }, 10);
  };

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.handleScroll();

      if (document.getElementById("focus_resetter")) {
        document.getElementById("focus_resetter").focus();
      }

      if (this.props.history.action === "POP") {
        this.props.clearErrors();
      }
    }

    const { loading, fetchingHistoryStatus } = this.props;

    if (loading !== prevProps.loading) {
      if (loading === false) {
        removeSvgFocusIE();
        handleAEMReactLink();
        
      }
      if (loading === true) {
        this.handleScroll();
      }
    }
    if (fetchingHistoryStatus !== prevProps.fetchingHistoryStatus && fetchingHistoryStatus === false) {
      removeSvgFocusIE();
      setTimeout(()=>{
        handleAEMReactLink()
    },1);
    
    }
  }

  render() {
    return <div>{this.props.children}</div>;
  }
}

const mapStateToProps = ({
  loadingAndErrorState: { loading },
  downloadAndDelete: { loading: fetchingHistoryStatus }
}) => ({
  loading,
  fetchingHistoryStatus
});

export default withRouter(
  connect(
    mapStateToProps,
    { clearErrors }
  )(ScrollToTop)
);
